// 林长任务相关接口
import request from '../utils/axios'

// 获取林长任务区域乡镇名称下拉框(工作人员) 1:查询，2：新增或编辑
export function GetTaskAreaBox(type) {
    return request({
      url: `/Forester/GetTaskAreaBox?type=${type}`,
      method: 'get',
    })
}

// 获取人员管理区域乡镇名称下拉框(工作人员) 1:查询，2：新增或编辑
export async function GetAreaBox(type) {
    return await request({
      url: `/Forester/GetAreaBox?type=${type}`,
      method: 'get',
    })
}

// 获取巡护人员列表(工作人员)
export function GetForesterUserLis(params) {
    return request({
      url: `/Forester/GetForesterUserLis`,
      method: 'post',
			data:params
    })
}

// 修改巡护信息(工作人员)
export function UpdateMyForesterPatrol(params) {
  return request({
    url: `/Forester/UpdateMyForesterPatrol`,
    method: 'post',
    data:params
  })
}

// 添加人员(工作人员)
export function AddForesterUser(params) {
    return request({
      url: `/Forester/AddForesterUser`,
      method: 'post',
			data:params
    })
}

// 获取林长人员详情接口(工作人员)
export async function GetForesterUserDetails(id) {
    return await request({
      url: `/Forester/GetForesterUserDetails?id=${id}`,
      method: 'get',
    })
}

// 修改巡护人员(工作人员)
export function UpdateForesterUser(params) {
    return request({
      url: `/Forester/UpdateForesterUser`,
      method: 'post',
			data:params
    })
}

// 删除巡护人员
export function DeleteForesterUser(id) {
    return request({
      url: `/Forester/DeleteForesterUser?id=${id}`,
      method: 'get',
    })
}

// 获取发布任务列表(工作人员)
export function GetForesterTaskLis(params) {
    return request({
      url: `/Forester/GetForesterTaskLis`,
      method: 'post',
			data:params
    })
}

// 根据管理区域获取 查询 林长任务列表 时林长姓名下拉框(工作人员)
export function GetForesterUserByArea(areaId) {
    return request({
      url: `/Forester/GetForesterUserByArea?areaId=${areaId}`,
      method: 'get',
    })
}

// 根据管理区域获取 发布和编辑 林长任务 时林长姓名下拉框(工作人员)
export function GetForesterUserByArea2(areaId) {
    return request({
      url: `/Forester/GetForesterUserByArea2?areaId=${areaId}`,
      method: 'get',
    })
}

// 发布单个任务(工作人员)
export function AddForesterTask(params) {
    return request({
      url: `/Forester/AddForesterTask`,
      method: 'post',
			data:params
    })
}

// 查看任务详情
export function GetForesterTaskDetails(id) {
    return request({
      url: `/Forester/GetForesterTaskDetails?id=${id}`,
      method: 'get',
    })
}

// 修改任务(工作人员)
export function UpdateForesterTask(params) {
    return request({
      url: `/Forester/UpdateForesterTask`,
      method: 'post',
			data:params
    })
}

// 删除任务(工作人员)
export function DeteleForesterTask(id) {
    return request({
      url: `/Forester/DeteleForesterTask?id=${id}`,
      method: 'get',
    })
}

// 根据任务清单Id获取巡护记录(工作人员)
export function GetJournalLisById(params) {
  return request({
    url: `/Forester/GetJournalLisById`,
    method: 'post',
    data:params
  })
}


// 获取巡护记录详情(工作人员)
export function GetJournalDetails(id) {
  return request({
    url: `/Forester/GetJournalDetails?id=${id}`,
    method: 'get',
  })
}

// 批量导出巡林日志Excel
export function DownExcel(params) {
  return request({
    url: `/Forester/DownExcel`,
    method: 'post',
    data:params,
    responseType:'blob'
  })
}

// 获取林长巡护列表(工作人员)
export function GetForesterPatrolLis(params) {
  return request({
    url: `/Forester/GetForesterPatrolLis`,
    method: 'post',
    data:params
  })
}

// 获取林长巡护详情(工作人员)
export function GetForesterPatrolDetails(id) {
  return request({
    url: `/Forester/GetForesterPatrolDetails?id=${id}`,
    method: 'get',
  })
}

// 获取巡护详情根据巡护Id(工作人员)
export function GetForesterPatroByIds(params) {
  return request({
    url: `/Forester/GetForesterPatroByIds`,
    method: 'post',
    data:params
  })
}

// 批量导出巡林日志汇总
export function DownXLRZZip(params) {
  return request({
    url: `/Forester/DownXLRZZip`,
    method: 'post',
    data:params,
		responseType:'blob'
  })
}

// 获取林长巡林次数汇总表
export function DownXLCountExcel(params) {
  return request({
    url: `/Forester/DownXLCountExcel`,
    method: 'post',
    data:params,
		responseType:'blob'
  })
}

// 导出个人年度任务
export function DownAnnualTasks(params) {
  return request({
    url: `/Forester/DownAnnualTasks`,
    method: 'post',
    data:params,
		responseType:'blob'
  })
}

// 获取总的林长统计（根据区域）(工作人员)
export function GetForesterCount(params) {
  return request({
    url: `/Forester/GetForesterCount`,
    method: 'post',
    data:params
  })
}

// 获林长个人统计排行(工作人员)
export function GetForesterCountByUserLis(params) {
  return request({
    url: `/Forester/GetForesterCountByUserLis`,
    method: 'post',
    data:params
  })
}

// 获取林长巡护详情统计(工作人员)
export function GetForesterCountByUserDetails(params) {
  return request({
    url: `/Forester/GetForesterCountByUserDetails`,
    method: 'post',
    data:params
  })
}

// 获取林长统计 单个区域(工作人员)
export function GetForesterCountByAreaId(params) {
  return request({
    url: `/Forester/GetForesterCountByAreaId`,
    method: 'post',
    data:params
  })
}

// 获取林长管理区域（只有区管理和镇管理）(工作人员)
export function GetForesterUserLevel() {
  return request({
    url: `/Forester/GetForesterUserLevel`,
    method: 'get'
  })
}

// 上传图片
export  function UploadImage(params) {
  return request({
      url: '/Forester/UploadImage',
      method: 'post',
      data: params
  })
}